import React from 'react'
import { Image } from '@/atoms/Image'
import { Display, ParagraphXL } from '@/atoms/Text'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'
import { useTranslate } from '@/utils/translate/translate-client'

export const HowItWorks = () => {
  const { t } = useTranslate('pif')

  const ourApps = t('ourApps', 'Our apps')

  return (
    <div
      className="flex flex-col-reverse items-center justify-between bg-cover bg-center py-28 lg:flex-row"
      style={{
        backgroundImage: `url(${getCloudinaryImageUrl({
          path: `/v1706800638/angel-studios/pif/f57b5fa7388fe7ad1213da7c4e95c95e.png`,
        })})`,
      }}
    >
      <div className="flex w-full flex-col items-center justify-center px-12 lg:pl-24 lg:pr-0">
        <div>
          <Display
            weight="bold"
            className="photon-heading-md sm:photon-heading-lg md:photon-heading-xl lg:photon-display mb-8 mt-4 leading-tight lg:mt-0"
          >
            {t('howDoesItWork', 'How does it work?')}
          </Display>
          <div className="flex flex-col gap-8">
            <ParagraphXL className="photon-paragraph-sm sm:photon-paragraph-md md:photon-paragraph-lg lg:photon-paragraph-xlmax-w-[600px] font-[375] text-gray-300">
              {t(
                'whenYouPayItForwardSeries',
                'When you Pay it Forward for a series, your contribution helps fund future episodes, ensuring the stories you love continue. For movies still in theaters, your donation purchases tickets for someone else to enjoy the film for free. For movies not currently in theaters, Pay it Forward can help fund essential elements, like translating  into other languages or supporting the creation of more entertainment that amplifies light.',
              )}
            </ParagraphXL>
            <ParagraphXL className="photon-paragraph-sm sm:photon-paragraph-md md:photon-paragraph-lg lg:photon-paragraph-xl max-w-[600px] font-[375] text-gray-300">
              {t(
                'inTheatersNoticeQRCode',
                `In theaters, you might also notice a QR code at the end of the film. Scanning it allows you to directly contribute to someone’s viewing experience by purchasing a ticket through the Pay it Forward feature.`,
              )}
            </ParagraphXL>
            <ParagraphXL className="photon-paragraph-sm sm:photon-paragraph-md md:photon-paragraph-lg lg:photon-paragraph-xl max-w-[600px] font-[375] text-gray-300">
              {t(
                'afterYouvePaidItForwardHelpExperience',
                `After you’ve paid it forward, you can track how many people you’ve helped experience the movie or show. Your support ensures that these meaningful stories reach even more people.`,
              )}
            </ParagraphXL>
          </div>
        </div>
      </div>
      <Image
        alt={ourApps}
        width={1024}
        height={915}
        className="lg:max-w-[50vw]"
        src="https://images.angelstudios.com/image/upload/v1706740881/angel-studios/pif/Frame_1261157318.png"
      />
    </div>
  )
}
